module.exports = __webpack_public_path__ + "img/discovercard.43d6108c.svg";